import React, { useState, useEffect, useContext, useRef, Suspense, lazy } from "react";
import "../ProjectTasks.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import { Col, Row } from "reactstrap";
import { Button, Checkbox, Select } from "antd";
import { GlobalSearch } from "../../GlobalSearch/GlobalSearch";
import GetElementsGroupBy from "../GetElementsGroupBy";
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import GanttView from "../GanttView";
import { ViewSwitcher } from "../viewSwitcher";
import { CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import BottomBar from "../BottomBar";
import SkeletonUI from "../SkeletonUI"; 
import { ViewMode } from "gantt-task-react";
import GetTaskSearchSetting from "./GetTaskSearchSetting";
import GetTaskFilterSetting from "./GetTaskFilterSetting";
import GetModalForEditColumns from "./GetModalForEditColumns";
import GetCriteriaModal from "./GetCriteriaModal";
import moment from "moment";
import { first, canAccess } from "../../../common/util/appUtils";
import TabView from "../../../common/tabs/tabs";
import {useSelector} from "react-redux"
import { SearchPopover } from "../../GlobalSearch/SearchPopover";
import UserFilterSelect from "../UserFilterSelect";
import SortManager from "../SortManager";
import AwsServerService from "../../../common/util/AwsServerService";
const RenderAllTasks = lazy(() => import('../RenderAllTasks'));

function TaskRelatedComponents({createTaskModal, viewTaskFunction,allPipeline,dropdownTasksDataCache,
    groupFilter, setGroupFilter,setCreateTaskModal, setViewTaskData,setInsertBelowData,dropdownTempTasksDataCache,pipelineTemplates,
     selectedTable,dealListTriggers,dealListStatus, setLoader, dealStatus,allTasksAndSubtasks,allTasksAndSubtasksTemp, accessedFromAccounts,
//     clientListStatus, clientListTriggers,
  setCheckType, checkType, params, location, setPageRefreshData, refreshData, fromBody, dealObj,
setDependencyRefresh,allDependeniesData,dependencyRefresh, setVisibleDeals,visibleDeals, DealName, allPipelineVisible, allTaskStatusTime, latestActivity }) {
        const [rangeObj, setRangeObj] = useState({from:0,to:10});
        const Alldeals = useSelector((state) => state.AppReduxContext.AllDeals || []);
        
//   const [itemsTaskGroup, setItemTaskGroup] = useState(groupByTaskItem);
//   const [itemDealGroup, setItemDealGroup] = useState(groupByDealItem);
   const [selectedData, onSelectedData] = useState({})
  const [searchSettings, setSearchSettings] = useState({
    TaskName: true,
    Description: false
  })
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const [criteriaModal, setCriteriaModal] = useState(false);
  const [activeView, setActiveView] = useState('List');
  const [selectedIds, setSelectedIds] = useState({ Task: [], Subtask: [] });
  const setFilteredDataForAll = useRef({});
  const [view, setView] = useState(ViewMode.Day);
  const [isChecked, setIsChecked] = useState(true); 
  const setFilteredDataForAllProjects = useRef({});
  const [dummyId, setDummyID] = useState({});
  const [searchText, setSearchText] = useState(""); 
 const [currentMonth, setCurrentMonth] = useState(moment().startOf('month'));
 const [assingedToMe, setAssingedToMe] = useState(false);
 const [underSupervision, setUnderSupervision] = useState(false);
 const [selectedUsersForFilter, setSelctedUsersForFilter] = useState([]);
 const [taskFilterSetting, setTaskFilterSetting] = useState({
     TaskLocation: false,
     SubtaskParntNames: false,
     ExpandDeals: true,
     ExpandGroups: true,
     ExpandTasks: false,
     ViewSeparateTask: false,
   });

   //tabView
    const [selected, setSelected] = useState(
       first.reduce((acc, item) => {
         acc[item] = true;
         return acc;
       }, {})
     );
   const [isInitialLoad, setInitialLoad] = useState(false);
   const [sortFilters, setSortFilters] = useState([]);
    const [refreshTab, setRefreshTab] = useState(false);
    const [allCacheRoles,setAllCacheRoles] = useState([])
    const [allCacheUserRoles,setAllCacheUserRoles] = useState([])
    const [preAppliedFiltersForView, setPreAppliedFiltersForView] = useState([]);

    useEffect(()=>{
      fetUserRoles();
      fetRoles();
    },[])

    const fetUserRoles = () => { 
          AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "USERROLES" }).then(res => {
              // setAllUserRoles(res.data); 
              setAllCacheUserRoles(res.data);
          }).catch(err => {
              console.log(err);
          })
      }
        const fetRoles = () => {
          AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "ROLES" }).then(res => {
              // setAllRoles(res.data);
              setAllCacheRoles(res.data);
          }).catch(err => {
              console.log(err);
          })
      }

  //tabView
   const setActiveFilterAndGetActiveFilters = async (filters, action, mainFilters) => {
      
      if (action === 'SET' && Object.keys(filters).length !== 0 && mainFilters.length !== 0) {
        setSelected(filters)
        setGroupFilter(mainFilters)
      } else {
        onSelectedData({});
        setGroupFilter({
          group1: { name: "Deal Name", value: "Deal_Name", extraKey: "Account_Name", sortOrder: "desc" },
          group2: { name: "Pipeline (Position)", value: "PipelineROWID", sortOrder: "asc"},
        })
        setSelected(first.reduce((acc, item) => {
          acc[item] = true;
          return acc;
        }, {}))
      }
    }
  const goToNextMonth = () => {
    setCurrentMonth(currentMonth.clone().add(1, 'month'));
  };

  const goToPreviousMonth = () => {
    setCurrentMonth(currentMonth.clone().subtract(1, 'month'));
  }; 

  useEffect(e => {
      setSelectedIds({ Task: [], Subtask: [] }) 
    }, [createTaskModal , selectedTable])

   const setActiveGlobalFilter = async (filters) => {
       if (filters && filters.length > 0) {
       onSelectedData(filters);
       }
       else {
       onSelectedData({});
       } 
   }
  return (<>
   {/* <GetModalForEditColumns clientListStatus={clientListStatus} clientListTriggers={clientListTriggers} setSelected={setSelected} selected={selected}/> */}
   {!fromBody && <div style={{ margin: "-53px 0 0 0" }}> 
            <TabView
              setInitialLoad={setInitialLoad}
              setRefreshTab={setRefreshTab}
              refreshTab={refreshTab}
              isInitialLoad={isInitialLoad}
              setPreAppliedFiltersForView={setPreAppliedFiltersForView}
              setActiveFiltersOnColumnLevel={setSelected}
              dealListStatus={dealListStatus}
              dealListTriggers={dealListTriggers}
              viewType={activeView}
              setActiveFilterAndGetActiveFilters={setActiveFilterAndGetActiveFilters}
              activeFiltersOnColumnLevel={selected}
              preAppliedFiltersForView={preAppliedFiltersForView}
              appliedFiltersForView={groupFilter}
              setappliedFiltersForView={()=>{}}
              checkType={checkType}
              setCheckType={setCheckType}
              params={params}
              location={location}
              setColumnsEdit={()=>{}}
              //columnsEdit={columnsEdit}
              getViewColumns={()=>{}}
              headerData={selected}
              module={location.state ? location.state.module : ""}
              globalFilterForView={selectedData}
              setGlobalFilter={setActiveGlobalFilter}
            />  
        </div>}
        <GetCriteriaModal onSelectedData={onSelectedData}
        selectedData={selectedData} setCriteriaModal={setCriteriaModal} view={view} criteriaModal={criteriaModal} allPipelineData={allPipeline}/>
        <Col className="Tasks-Tab-Wrapper" sm={12}>
          <Row className="Header" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <Col style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "row", gap: "10px"
                  ,left: '3.8rem', paddingLeft: '2em'}} sm={fromBody?10:7}>           
              {activeView == 'List' ? <> <div className="checkboxAndSearch">
                {/*Main Check box */}
                <Checkbox
                  checked={setFilteredDataForAll.current.length == selectedIds.Task.length}
                  indeterminate={setFilteredDataForAll.current.length > selectedIds.Task.length && selectedIds.Task.length != 0}
                  className='Category-CheckBox'
                  onClick={(e) => {
                    let resultArray = [];
                    let object = {}
                    if (e.target.checked) {
                      let data = setFilteredDataForAllProjects.current;
                      for (const key in data) {
                        if (!_.isEmpty(data[key])) {
                          const obj = data[key];
                          for (const subKey in obj) {
                            let arrayData = obj[subKey]?.map(item => item?.TaskROWID);
                            object[`${key}_${subKey}`] = [...arrayData];
                            resultArray.push(...arrayData);
                          }
                        }
                      }
                      setDummyID(object)
                      setFilteredDataForAll.current = resultArray;
                      setSelectedIds({ Task: [...resultArray], Subtask: [] })
                    } else {
                      setDummyID({})
                      setSelectedIds({ Task: [], Subtask: [] })
                    }
                  }}
                />
                {/* Global Search */}
                <div>
                <div style={{ position: 'relative', width: '250px' }}>
            <GlobalSearch
              tasks={true}
              text={searchText}
              onSearchFilterTexts={(text) => setSearchText(text)}
            />
            {!!searchText && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      width: "97%",
                      fontWeight: "500",
                      color: "#5b6c97",
                      background: "#fff",
                      border: "1px solid #ddd",
                      borderTop: "none",
                      padding: "6px 10px",
                      boxShadow: "0 3px 8px rgba(0,0,0,0.12)",
                      zIndex: 1000
                    }}
                  >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontSize: 13 }}>Task Name</span>
                    <Checkbox
                      checked={searchSettings.TaskName}
                      onChange={(e) =>
                        setSearchSettings({
                          ...searchSettings,
                          TaskName: e.target.checked
                        })
                      }
                    />
                  </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 4 }}>
                  <span style={{ fontSize: 13 }}>Task Description</span>
                    <Checkbox
                          checked={searchSettings.Description}
                          onChange={(e) =>
                            setSearchSettings({
                              ...searchSettings,
                              Description: e.target.checked
                            })
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
                  {/* { !!searchText && <span style={{ top: '-3px', left: '6.8rem', position: 'absolute', 
                backgroundColor: 'rgb(239 137 137)', color: 'white', borderRadius: '50%', width: '16px', 
                height: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight:'600'}}>
                {<FontAwesomeIcon icon={faTimes} onClick={() => setSearchText('')} /> }</span>} */}
              </div>
              </div> </> :
                (<><ViewSwitcher
                  onViewModeChange={(viewMode) => setView(viewMode)}
                  viewMode={view}
                  onViewListChange={setIsChecked}
                  isChecked={isChecked}
                /> 
                  <Button className={'btnclass'} onClick={() => goToPreviousMonth()} type="primary" ghost icon={<LeftOutlined />} iconPosition="start">  Prev </Button>
                  <Button className={'btnclass'} onClick={() => goToNextMonth()} type="primary" icon={<RightOutlined />} iconPosition="end" ghost>Next</Button>
                </>)
              }
              {/* Task Search Setting */}
              {/* {activeView == 'List' && <GetTaskSearchSetting searchSettings={searchSettings} setSearchSettings={setSearchSettings}/>} */}
              {/* Group By */}
              {activeView == 'List' && <div style={!!searchText?{marginLeft: '5px'}:{}}>
                <GetElementsGroupBy 
                  setTaskFilterSetting={setTaskFilterSetting}
                  taskFilterSetting={taskFilterSetting}
                  groupByFilter={groupFilter}
                  setGroupFilter={(data) => setGroupFilter(data)} 
                />
              </div>} 
              {/* Manage Columns */}
              <GetModalForEditColumns setSelected={setSelected} selected={selected} />
              {/* Sorting option */}
              <SortManager sortFilters={sortFilters} setSortFilters={setSortFilters} />

              {/* User Filter */}
              
              {activeView == 'List' && <span style={{ backgroundColor: "#0194f7", cursor: "pointer", height: '22px', width: "30px", textAlign: "center", paddingTop: "3px",position: "relative", marginLeft: '5px' }}>
                  <FontAwesomeIcon
                    onClick={() => {
                      setCriteriaModal(true)
                    }}
                    color="white"
                    icon={faFilter}
                  />
                  {selectedData?.length > 0 ? <span className="criteria-count" style={{color:"white"}}>{selectedData.length}</span> : null}
                  {selectedData.length > 0 && (
                            <CloseOutlined
                              className="closedIcondelete"
                              onClick={(e) => {
                                e.stopPropagation();
                                onSelectedData([]);
                              }}
                              style={{
                                position: "absolute",
                                top: -4,
                                right: -4,
                                fontSize: 12,
                                cursor: "pointer",
                                color: "red",
                              }}
                            />
                          )}
                </span>}
              <div>
                <UserFilterSelect 
                  setUnderSupervision={setUnderSupervision}
                  setAssingedToMe = {setAssingedToMe}
                  setSelctedUsersForFilter={setSelctedUsersForFilter}
                />
                { (assingedToMe || underSupervision || selectedUsersForFilter.length > 0) && <span style={{ top: '-3px', left: (!!searchText && sortFilters.length > 0)?'38.2rem' : searchText ? '36rem' :sortFilters.length > 0? '37.9rem': '35.9rem', position: 'absolute', 
                  backgroundColor: 'rgb(239 137 137)', color: 'white', borderRadius: '50%', width: '16px', 
                  height: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight:'600'}}>
                  {(assingedToMe ? 1 : 0) + (underSupervision ? 1 : 0) + selectedUsersForFilter.length}</span>}
              </div>
            </Col>
            <Col style={{ display: "flex", justifyContent: "end", alignItems: "center", flexDirection: "row", gap: "5px" }} sm={fromBody?2:5}>
              {/* Views */}
              {/* <div className="list-compact-view">
                <div onClick={(e) => { setActiveView("List") }} className="list-view" style={activeView == "List" ? { background: "#018EE0", color: "#fff" } : { background: "#fff" }}>List View</div>
                <div onClick={(e) => { setActiveView("Gantt") }} className="compact-view" style={activeView == "Gantt" ? { background: "#018EE0", color: "#fff" } : { background: "#fff" }}>Gantt View</div>
              </div> */}
              {/* Task Filter Setting (Collapse) */}
              {activeView == 'List' ? <GetTaskFilterSetting setTaskFilterSetting={setTaskFilterSetting}
              taskFilterSetting={taskFilterSetting} /> : <></>}
              {(activeView == 'List' && !fromBody) ? <div style={{display: 'flex',flexDirection: 'row',alignItems: 'center',gap: '1rem'}}>
                <FontAwesomeIcon opacity={(rangeObj?.from==0 || (!!searchText?.trim() || selectedUsersForFilter.length > 0 ||assingedToMe || underSupervision || selectedData?.length > 0))?0.5:1} style={{cursor:'pointer',padding: "4px",color: '#4a577a'}} 
                size="2x" icon={faAngleDoubleLeft} onClick={()=>{
                  if(rangeObj.from == 0 || (!!searchText?.trim() || assingedToMe || selectedUsersForFilter.length > 0||underSupervision || selectedData?.length > 0)) return;
                  setVisibleDeals(Alldeals.slice(0, 10));
                  setRangeObj({ from: 0, to: Alldeals.length < 10 ? Alldeals.length : 10 });
                }}/>
                <FontAwesomeIcon opacity={(rangeObj?.from==0 || (!!searchText?.trim() || selectedUsersForFilter.length > 0||assingedToMe || underSupervision || selectedData?.length > 0))?0.5:1} style={{cursor:'pointer',padding: "2px",color: '#4a577a'}} 
                size="2x" icon={faAngleLeft} onClick={()=>{
                  if(rangeObj.from == 0 || (!!searchText?.trim() || assingedToMe ||selectedUsersForFilter.length > 0|| underSupervision || selectedData?.length > 0)) return;
                  let from = rangeObj.from - 10;
                  let to = rangeObj.from;
                  setVisibleDeals(Alldeals.slice(from, to));
                  setRangeObj({from:from,to:to})
                }}/>
                <span>{(!!searchText?.trim() || assingedToMe || selectedUsersForFilter.length > 0 || underSupervision || selectedData?.length > 0)?`1 to ${Alldeals.length} of ${Alldeals.length}`:`${rangeObj?.from+1} to ${rangeObj?.to} of ${Alldeals.length}`}</span>
                <FontAwesomeIcon opacity={(rangeObj?.to==Alldeals.length || (!!searchText?.trim() ||selectedUsersForFilter.length > 0|| assingedToMe || underSupervision || selectedData?.length > 0))?0.5:1} 
                style={{cursor:'pointer',padding: "2px",color: '#4a577a'}} 
                size="2x" icon={faAngleRight} onClick={()=>{
                  if(rangeObj.to == Alldeals.length || (!!searchText?.trim() || selectedUsersForFilter.length > 0 || assingedToMe || underSupervision || selectedData?.length > 0)) return;
                  let from = rangeObj.to;
                  let to = from + 10 > Alldeals.length ? Alldeals.length : from + 10;
                  setVisibleDeals(Alldeals.slice(from, to));
                  setRangeObj({from:from,to:to})
                }}/>
                <FontAwesomeIcon opacity={(rangeObj?.to==Alldeals.length || (!!searchText?.trim() || assingedToMe ||selectedUsersForFilter.length > 0|| underSupervision || selectedData?.length > 0))?0.5:1} 
                style={{cursor:'pointer',padding: "4px",color: '#4a577a'}} 
                size="2x" icon={faAngleDoubleRight} onClick={()=>{
                  if(rangeObj.to == Alldeals.length || (!!searchText?.trim() || assingedToMe || underSupervision ||selectedUsersForFilter.length > 0 || selectedData?.length > 0)) return;
                  const lastPageCount = Alldeals.length % 10 || 10;
                  const from = Alldeals.length - lastPageCount;
                  const to = Alldeals.length; 
                  setVisibleDeals(Alldeals.slice(from, to));
                  setRangeObj({ from, to });
                }}/>
              </div> : <></>}
              <Button style={{
                ...(fromBody? {background: '#018ee0', fontWeight: '500'}:{ position: 'absolute', bottom: '2.5rem', zIndex:'1', background: '#018ee0', fontWeight: '500'}),
              ...(!canAccess(accessContext, "Tasks", "Create") && { cursor: 'not-allowed', opacity: 0.6})
              }} type="primary" onClick={e => {
              if(canAccess(accessContext, "Tasks", "Create")){
                setCreateTaskModal(true);
                setViewTaskData(null);
                setInsertBelowData({})
              }
              }}>Add Task</Button> 
            </Col>
          </Row>
          {activeView == 'List' ? <Suspense fallback={<SkeletonUI/>}><RenderAllTasks
            selectedFilterValues={selectedData}
            pipelineTemplates={pipelineTemplates}
            allCacheUserRoles={allCacheUserRoles}
            allCacheRoles={allCacheRoles}
            selectedUsersForFilter={selectedUsersForFilter}
            sortFilters={sortFilters}
            fromBody = {fromBody}
            accessedFromAccounts={accessedFromAccounts}
            dealObj =  {dealObj}
            setSelctedUsersForFilter={setSelctedUsersForFilter}
            selectedTable={selectedTable}
            visibleDeals={visibleDeals}
            setVisibleDeals={setVisibleDeals}
            setLoader={setLoader}
            searchText={searchText}
            assingedToMe={assingedToMe}
            underSupervision={underSupervision}
            searchSettings={searchSettings} 
            taskFilterSetting={taskFilterSetting}
            setTaskFilterSetting={setTaskFilterSetting}
            DealStatus={dealStatus}
            viewTaskFunction={viewTaskFunction}
            group={groupFilter}
            allPipelineData={allPipeline}
            refreshData={refreshData}
            setPageRefreshData={setPageRefreshData}
            dropdownTasksDataCache={selectedTable == "tasks" ? dropdownTasksDataCache : dropdownTempTasksDataCache}
            allTasksAndSubtasks={selectedTable == "tasks" ? allTasksAndSubtasks : allTasksAndSubtasksTemp}
            allDependeniesData={allDependeniesData}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            dummyId={dummyId}
            setDummyID={setDummyID}
            setFilteredDataForAllProjects={setFilteredDataForAllProjects}
            setDependencyRefresh={setDependencyRefresh}
            dependencyRefresh={dependencyRefresh}
            selected={selected}
            allPipelineVisible = {allPipelineVisible}
            DealName={DealName}
            allTaskStatusTime = {allTaskStatusTime} 
            latestActivity = {latestActivity}
          /></Suspense> : <GanttView
            view={view}
            isChecked={isChecked}
            currentMonth={currentMonth}
            setCurrentMonth={setCurrentMonth}
          />
          }
        </Col>
        {(selectedIds?.Task?.length > 0 || selectedIds?.Subtask?.length > 0) &&
          <BottomBar
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            setPageRefreshData={setPageRefreshData}
            refreshData={refreshData}
            selectedTable={selectedTable}
            setIsAdding={() => { }}
            allPipelineData={allPipeline}
            setSubEditData={() => { }}
            setUpdateFlag={() => { }}
            DealName = {DealName}
            allTasksAndSubtasks = {allTasksAndSubtasks}
          />}
      </>
  )
}
export default React.memo(TaskRelatedComponents);